$(document).ready(function(){
  $('body').on('click','.toggle-box__label', function() {
    $(this).toggleClass('active')
    $(this).parent().find('.pdp__details-description').toggleClass('active');
  });

     
  $('.customRecom').each(function(){
    var d = $(this);
    var u = d.attr('data-handle');
    $.get('/products/'+u+'?view=recomd_grid', function(r){
      d.html(r);
      // setTimeout(function(){
      //   var clr = d.attr('data-clr');
      //   var img = d.find('input[value="'+clr+'"]').attr('data-href');
      //   if(clr!="") {
      //     console.log(d.find('input[value="'+clr+'"]').length,'sssssss');
      //     // d.find(".indiv-product").find(".grid__image img").attr('data-lowsrc',img).attr('data-srcset',img).attr('srcset',img).attr('src',img).removeClass('lazyload')
      //     // d.find('input[value="'+clr+'"]').prop("checked", true).trigger("click");
      //     d.find('input[value="'+clr+'"]').addClass('active').trigger("click");
      //     //d.find('.indiv-product__swatches, .hidden').remove();
      //   }
      // },500)
    })
  });
  
   if($('.customRecomd.no_color').length > 0){
    $('product-recommendations').hide();
    $('.customRecomd.no_color').show();
   }
  
});